import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import api from '../api';

const ResetPassword = () => {
    const { uid, token } = useParams();
    console.log("ResetPassword: UID and Token received from URL:", { uid, token });
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(''); // 'success' or 'error'
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setMessage('Las contraseñas no coinciden');
            setStatus('error');
            return;
        }

        try {
            await api.post('auth/password/reset/confirm/', {
                uid,
                token,
                new_password1: password,
                new_password2: confirm
            });
            setMessage('¡Contraseña restablecida con éxito! Redirigiendo al login...');
            setStatus('success');
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            let errorMsg = 'Error al restablecer la contraseña. El link puede haber expirado o ser inválido.';
            
            if (err.response?.data) {
                const data = err.response.data;
                // Si es un objeto, intentamos extraer los mensajes de error
                if (typeof data === 'object') {
                    const messages = Object.values(data).flat();
                    if (messages.length > 0) {
                        errorMsg = messages[0];
                    }
                }
            }
            
            setMessage(errorMsg);
            setStatus('error');
        }
    };

    return (
        <div className="login-page">
            <div className="login-overlay"></div>
            <div className="login-content-container animate-fade-in">
                <div className="login-card glassmorphism p-5 shadow-2xl">
                    <div className="text-center mb-4">
                        <h2 className="section-title">Restablecer Contraseña</h2>
                        <p className="text-muted">Ingresa tu nueva contraseña a continuación.</p>
                    </div>

                    {message && (
                        <div className={`alert ${status === 'success' ? 'alert-success' : 'alert-danger'} mb-4 text-center`}>
                            {message}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-floating mb-3 position-relative">
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="form-control pe-5" 
                                placeholder="Nueva Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <label>Nueva Contraseña</label>
                            <button
                                type="button"
                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent text-muted me-2"
                                style={{ zIndex: 10 }}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                        <div className="form-floating mb-4 position-relative">
                            <input 
                                type={showConfirmPassword ? "text" : "password"} 
                                className="form-control pe-5" 
                                placeholder="Confirmar Contraseña"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                required
                            />
                            <label>Confirmar Contraseña</label>
                            <button
                                type="button"
                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent text-muted me-2"
                                style={{ zIndex: 10 }}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                        <button type="submit" className="btn btn-primary-gradient w-100 py-3 font-bold">
                            RESTABLECER CONTRASEÑA
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
